import React from 'react'

import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

interface InfoElementProps {
  label: string | JSX.Element
  value: string | JSX.Element | number | undefined
}

const InfoElement = (props: InfoElementProps): JSX.Element => {
  return (
    <Stack>
      {typeof props.label === 'string' && (
        <Typography component="div" variant="subtitle2" sx={{ py: 1 }}>
          {props.label}
        </Typography>
      )}
      {React.isValidElement(props.label) && (
        <Typography component="div" variant="subtitle2">
          {props.label}
        </Typography>
      )}
      <Typography component="div" variant="body2">
        {props.value}
      </Typography>
    </Stack>
  )
}

export default InfoElement
